import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid } from "@material-ui/data-grid";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";

import Modal from "../../../components/Modal/Modal";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";

//Global state Access
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

import VenueView from "./VenueView";
import VenueAddModal from "../Add/VenueAddModal";
import VenueUpdateModal from "../Update/VenueUpdateModal";

const VenueListChild = () => {
  let navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [data, setData] = useState([]);
  const [{ errorLogApi, placeHolderText, user }] = useAtom(gbState);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const toggleAddModal = () => {
    setShowAddModal(!showAddModal);
  };

  const toggleUpdateModal = () => {
    setShowUpdateModal(!showUpdateModal);
  };

  const handleDelete = (row) => {
    confirmAlert({
      title: "",
      message: "Are you sure to delete this Venue ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecord(row),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecord = (row) => {
    let userToken = localStorage.getItem("token");
    let apiUrl = `${process.env.REACT_APP_API_URL}/venues/delete/${row.id}`;
    let payload = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(apiUrl, payload)
      .then((response) => {
        console.log(response);
        getDataFromServer();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getDataFromServer = () => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/venues/${user.church_id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data.users));
        const oldData = response.data.venues;
        const updatedData = oldData.map((data) => {
          return {
            ...data,
            id: data._id,
            venue_name: data.venue_name,
            description: data.description,
            church_name: data?.church_id,
          };
        });

        setData(updatedData);
      })
      .catch(function (err) {
        console.log("error api call ", err.response.data.message);
      });
  };

  useEffect(() => {
    getDataFromServer();
  }, []);

  const columns = [
    {
      field: "Action",
      headerName: "Action",
      sortable: false,
      hideable: false,
      disableColumnMenu: true,
      width: 80,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="flex flex-row">
            <Tooltip title="View  details">
              <div
                onClick={() => {
                  toggleModal();
                  setCurrentRecord(params.row);
                }}
              >
                <i
                  className="cursor-pointer mdi mdi-eye-circle-outline"
                  style={{ fontSize: "15px", color: "black" }}
                ></i>
              </div>
            </Tooltip>
            <Tooltip title="Edit">
              <div
                onClick={() => {
                  toggleUpdateModal();
                  setCurrentRecord(params.row);
                }}
              >
                <i
                  className="mdi mdi-square-edit-outline"
                  style={{ fontSize: "15px", color: "grey", cursor: "pointer" }}
                ></i>
              </div>
            </Tooltip>
            <Tooltip title="Delete">
              <div
                onClick={() => {
                  handleDelete(params.row);
                }}
              >
                <i
                  className="mdi mdi-trash-can-outline"
                  style={{ fontSize: "15px", color: "red", cursor: "pointer" }}
                ></i>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "venue_name",
      headerName: "Name",
      width: 140,
    },
    {
      field: "description",
      headerName: "Description",
      width: 200,
    },
    // {
    //   field: "church_name",
    //   headerName: "Church",
    //   width: 140,
    // },
  ];

  return (
    <div className="w-full" style={{ wordBreak: "break-word" }}>
      <div className="flex justify-end w-full">
        <button
          className="px-4 py-2 text-white bg-gray-600 rounded hover:bg-gray-900"
          onClick={() => {
            toggleAddModal();
          }}
        >
          Add Venue
        </button>
      </div>
      <h2>All Venues</h2>
      <ErrorBoundaryRoutes route="/venues" page="ModalView">
        {showModal && (
          <Modal onClose={toggleModal}>
            <h2 className="mb-4 text-xl font-bold">Venue Detail</h2>
            <VenueView currentRecord={currentRecord} />
          </Modal>
        )}
      </ErrorBoundaryRoutes>

      <ErrorBoundaryRoutes route="/venues" page="ModalView">
        {showAddModal && (
          <Modal onClose={toggleAddModal}>
            <VenueAddModal
              onClose={toggleAddModal}
              getDataFromServer={getDataFromServer}
            />
          </Modal>
        )}
      </ErrorBoundaryRoutes>

      <ErrorBoundaryRoutes route="/venues" page="ModalView">
        {showUpdateModal && (
          <Modal onClose={toggleUpdateModal}>
            <VenueUpdateModal
              onClose={toggleUpdateModal}
              getDataFromServer={getDataFromServer}
              currentRecord={currentRecord}
            />
          </Modal>
        )}
      </ErrorBoundaryRoutes>
      {/* {JSON.stringify(data)} */}
      <div className="mt-4">
        <DataGrid
          rows={data}
          disableSelectionOnClick
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          displayTitle="Venues"
          checkboxSelection
          style={{ height: "40vh" }}
        />
      </div>
    </div>
  );
};
export default VenueListChild;
